import { render, staticRenderFns } from "./modalGaleriaVista.vue?vue&type=template&id=0f14e9fe&scoped=true"
import script from "./modalGaleriaVista.vue?vue&type=script&lang=js"
export * from "./modalGaleriaVista.vue?vue&type=script&lang=js"
import style0 from "./modalGaleriaVista.vue?vue&type=style&index=0&id=0f14e9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14e9fe",
  null
  
)

export default component.exports